import React from "react";
import { Switch, Route } from "react-router-dom";

import Login from "./pages/preLogin/Login";
import SignUp from "./pages/preLogin/SignUp";
import ForgotPassword from "./pages/preLogin/ForgotPassword";
import ResetPassword from "./pages/preLogin/ResetPassword";
import GetStarted from "./pages/preLogin/GetStarted";

import NotFound from "./pages/other/NotFound";

import CommunityInformation from "./pages/communityInformation/CommunityInformation";

import BookingSystem from "./pages/bookingSystems/BookingSystem";
import MyBookings from "./pages/bookingSystems/MyBookings";

import NewErrorReport from "./pages/errorReports/NewErrorReport";

import LaundryBooking from "./pages/laundries/LaundryBooking";
import MyLaundryBookings from "./pages/laundries/MyBookings";

import News from "./pages/feeds/News";

import MyPage from "./pages/generalSettings/MyPage";

import * as Constants from "../helpers/Constants";

function getNewErrorReportScreen() {
  return NewErrorReport;
}

const Router = () => (
  <Switch>
    <Route exact path={"/"} component={Login} />
    <Route exact path={"/signup"} component={SignUp} />
    <Route exact path={"/getstarted"} component={GetStarted} />
    <Route exact path={"/mylaundrybookings"} component={MyLaundryBookings} />
    <Route exact path={"/forgotpassword"} component={ForgotPassword} />
    <Route path={"/resetpassword/:idToken"} component={ResetPassword} />
    <Route
      exact
      path={"/newerrorreport"}
      component={getNewErrorReportScreen()}
    />
    <Route exact path={"/laundrybookings"} component={LaundryBooking} />
    <Route exact path={"/news"} component={News} />
    <Route exact path={"/mypage"} component={MyPage} />
    <Route
      exact
      path={"/communityinformation"}
      component={CommunityInformation}
    />
    <Route exact path={"/mybookings"} component={MyBookings} />
    <Route exact path={"/mybookings/:id"} component={MyBookings} />
    <Route exact path={"/bookingsystems"} component={BookingSystem} />
    <Route exact path={"/bookingsystems/:id"} component={BookingSystem} />

    <Route
      exact
      path={"/testmode/laundrybookings"}
      render={props => <LaundryBooking offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/mylaundrybookings"}
      render={props => <MyLaundryBookings offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/newerrorreport"}
      render={props => <NewErrorReport offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/communityinformation"}
      render={props => <CommunityInformation offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/news"}
      render={props => <News offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/mypage"}
      render={props => <MyPage offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/bookingsystems"}
      render={props => <BookingSystem offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/bookingsystems/:id"}
      render={props => <BookingSystem offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/mybookings"}
      render={props => <MyBookings offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/mybookings/:id"}
      render={props => <MyBookings offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode/*"}
      render={props => <LaundryBooking offlineMode {...props} />}
    />
    <Route
      exact
      path={"/testmode"}
      render={props => <LaundryBooking offlineMode {...props} />}
    />
    <Route exact path={"*"} component={NotFound} />
  </Switch>
);

export default Router;



// WEBPACK FOOTER //
// ./src/components/Router.js